export const BLUE = 0x1565c0
export const GREENISH = 0x66ff7f
export const COLOR_PRIMARY = 0x4e342e
export const COLOR_LIGHT = 0x7b5e57
export const COLOR_DARK = 0x260e04
